import dataLedMonochrome from "../themes/data-led-monochrome-theme.json";
import editorialWarmth from "../themes/editorial-warmth-theme.json";
import magazineVibrancy from "../themes/magazine-vibrancy-theme.json";
import type { ThemeV2 } from "./theme-v2-types";

export type VerifiedLibraryStyleId =
  | "editorial-warmth"
  | "data-led-monochrome"
  | "magazine-vibrancy";

export const VERIFIED_LIBRARY_STYLE_PACKS = Object.freeze({
  "editorial-warmth": editorialWarmth as ThemeV2,
  "data-led-monochrome": dataLedMonochrome as ThemeV2,
  "magazine-vibrancy": magazineVibrancy as ThemeV2,
} satisfies Record<VerifiedLibraryStyleId, ThemeV2>);
